import React, {Component, PropTypes} from 'react';
import {Button, Modal} from '@sketchpixy/rubix';
import styled from 'styled-components';

const BillingLink = styled.a`
  margin-left: 5px;
`;

class SuccessModal extends Component {
  render() {
    return (
        <Modal
            show={this.props.showModal}
            onHide={this.props.closeModal}
            backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title>Contract creation success</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h4>Do you want to open billing page?</h4>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.props.closeModal}>No</Button>
            <BillingLink href={this.props.billingUrl} target="_blank">
              <Button bsStyle="brownishgray" onClick={this.props.closeModal}>
                Yes
              </Button>
            </BillingLink>
          </Modal.Footer>
        </Modal>
    );
  }
}

SuccessModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  billingUrl: PropTypes.string.isRequired,
};

export default SuccessModal;



// WEBPACK FOOTER //
// ./src/routes/payment/SuccesesModal/SuccessModal.js